import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as webRTCActions from 'actions/chat/webrtc';
import ChooseCamera from 'components/chat/webrtc/chooseCamera';

export default connect(
  state => {
    let { clientConfiguration } = state.chat.main;

    return {
      prefered: clientConfiguration.preferedCamera,
      question: clientConfiguration.chooseCameraQuestionLabel,
      front: clientConfiguration.chooseFrontalCameraLabel,
      back: clientConfiguration.chooseBackCameraLabel,
      cancel: clientConfiguration.cancelChooseCameraLabel,
    }
  },
  dispatch => bindActionCreators({
    onChoose: webRTCActions.chooseCamera,
    onCancel: webRTCActions.cancelChooseCamera,
  }, dispatch)
)(ChooseCamera);



// WEBPACK FOOTER //
// ./containers/chat/webrtc/chooseCamera.js